import * as constants from '../constants';
import { createInitialProtocol } from '../constants';

const initialState = { error: false };

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createInitialProtocol.success: {
            return action.payload;
        }


        case constants.createInitialProtocol.try: {
            return initialState;
        }
        case constants.createInitialProtocol.error: {
            return { error: true };
        }

        default:
            return state;
    }
}